<template>
  <div v-if="cancel">
    <SEntrega99Cancel @save="onSave" @cancel="onCancel" />
  </div>
  <div v-else style="display: flex; flex-direction: column; height: 100%">
    <div v-if="showConfig" class="s-card e99-config" style="margin: 5px 2px">
      <div style="margin: 6px 10px">
        <s-onoff v-model="value.active" text="99Entrega"></s-onoff>
      </div>
      <div class="e99-grid">
        <label>Client id:</label>
        <input v-model="value.clientId" maxlength="100">
        <label>Client secret:</label>
        <input v-model="value.clientSecret" maxlength="100">
        <label>Key signature (webhook):</label>
        <input v-model="value.keySignature" maxlength="100">
      </div>
    </div>
    <SEntrega99Info ref="info" :value="value" :status="status"
      :showConfig="showConfig" :info="info" :enderecos="enderecos"
      @save="onSave" />
  </div>
</template>

<script>
import SEntrega99Info from "./SEntrega99Info.vue";
import SEntrega99Cancel from "./SEntrega99Cancel.vue";

export default {
  name: "s-entrega99",
  components: { SEntrega99Info, SEntrega99Cancel },
  props: {
    value: { type: Object, default: () => ({}) },
    showConfig: { type: Boolean, default: false },
    cancel: { type: Boolean, default: false },
    status: { type: String, default: "" },
    info: { type: Object, default: () => ({}) },
    enderecos: { type: Array, default: () => [] },
  },
  methods: {
    triggerSave(action) {
      if (this.showConfig) {
        this.$emit("save", { ...this.value, ...this.$refs.info.localValue });
        return;
      }
      this.$refs.info.save(action);
    },
    onSave(info) {
      this.$emit("save", this.showConfig ? this.value : info);
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.e99-config {
  flex-shrink: 0;
}

.e99-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 8px 10px;
  margin: 6px 2px;
}

.e99-grid label {
  white-space: nowrap;
}
</style>